export default __webpack_public_path__ + "static/media/alert.144b6c7d.svg";